import React from 'react';
import ResultsExcelTableContainer from '../containers/ResultsExcelTableContainer';

class WhatIfResultsExcelPres extends React.Component {
  render() {
    const { onDownloadExcel } = this.props;

    return (
      <div className="whatif-results">
        <div className="whatif-results-header">
          <button class={'header-button'} onClick={onDownloadExcel} disabled={this.props.isLoading}>
            Download Excel
          </button>
        </div>
        <div className="whatif-results-body whatif-results-excel-table">
          <ResultsExcelTableContainer results={this.props.results} />
        </div>
      </div>
    );
  }
}

export default WhatIfResultsExcelPres;
